import { useState } from "react";
import { Loader2, Mail } from "lucide-react";
import { toast } from "sonner";
import { api, formatApiError } from "@/lib/api";

export const AdminDigestButton = () => {
  const [loading, setLoading] = useState(false);

  const send = async () => {
    setLoading(true);
    try {
      const r = await api.post("/admin/digest/send");
      toast.success(`Digest sent: ${r.data.leads} lead(s), ${r.data.estimates} estimate(s), ${r.data.commercial_plans} commercial request(s)`);
    } catch (err) {
      toast.error(formatApiError(err.response?.data?.detail));
    } finally {
      setLoading(false);
    }
  };

  return (
    <button onClick={send} disabled={loading} data-testid="admin-send-digest-btn"
      className="border-2 border-brand text-brand hover:bg-brand hover:text-white disabled:opacity-60 font-bold px-5 py-3 rounded-sm flex items-center gap-2 transition-colors duration-200">
      {loading ? <Loader2 className="w-4 h-4 animate-spin" /> : <Mail className="w-4 h-4" />}
      Send Me This Week's Digest Now
    </button>
  );
};
